<template>
  <v-container class="futuristic-container">
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <h4 class="earth-color" v-if="this.$route.name === 'EditVisitor'">UPDATE AUTHORIZED VISITOR</h4>
        <h4 class="earth-color" v-else>REGISTER AUTHORIZED VISITOR</h4>
        <div class="title-decoration"></div>
      </v-card-title>
      <v-container>
        <v-form @submit.prevent="postVisitor()">
          <v-layout row wrap>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="visitor.check_in_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Check-in Date"
                    v-model="visitor.check_in_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker
                    v-model="visitor.check_in_date"
                    :min="start_date"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="modal1 = false"
                      class="futuristic-btn"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="$refs.dialog.save(visitor.check_in_date)"
                      class="futuristic-btn"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="visitor.check_out_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Check-out Date"
                    v-model="visitor.check_out_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker
                    v-model="visitor.check_out_date"
                    :min="visitor.check_in_date"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="modal2 = false"
                      class="futuristic-btn"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="$refs.dialog1.save(visitor.check_out_date)"
                      class="futuristic-btn"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Visitor Type"
                  v-model="visitor.type"
                  :items="AllVisitorTypes"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="visitor_type_name"
                  item-value="visitor_type_public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Organization"
                  v-model="visitor.organisation"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Name"
                  v-model="visitor.name"
                  :rules="requiredRules"
                  required
                  max="50"
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg2 md6 sm12 xs12>
              <v-container>
                <v-autocomplete
                  label="Country"
                  v-model="visitor.code"
                  :items="allCountries"
                  :rules="[v => !!v || 'Country is required']"
                  required
                  item-text="name"
                  item-value="code"
                  @change="findCountryCode"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg4 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Phone Number"
                  v-model="visitor.phone"
                  :rules="requiredRules"
                  required
                  type="tel"
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container fluid>
                <v-select
                  label="Identification Type"
                  v-model="visitor.id_type"
                  :items="AllIdentificationTypes"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="identification_type_name"
                  item-value="identification_type_public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-select>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Identification Number"
                  v-model="visitor.id_number"
                  :rules="requiredRules"
                  required
                  max="15"
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-textarea
                  label="Purpose of Visit"
                  v-model="visitor.purpose"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-textarea>
              </v-container>
            </v-flex>
            <v-flex lg6 md6 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Vehicle Registration"
                  v-model="visitor.plate"
                  :rules="requiredRules"
                  required
                  max="30"
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-text-field
                  label="Number of Persons"
                  v-model="visitor.count"
                  :rules="requiredRules"
                  required
                  min="1"
                  type="number"
                  class="futuristic-input"
                ></v-text-field>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Destination"
                  v-model="visitor.destination"
                  :items="allDestinations"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="destination_name"
                  item-value="destination_public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container fluid>
                <v-autocomplete
                  label="Visitor Authorizer"
                  v-model="visitor.staff"
                  :items="allStaff"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="full_name"
                  item-value="public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
              </v-container>
            </v-flex>
            <v-flex lg12 md12 sm12 xs12>
              <v-container fluid>
                <v-btn
                  :depressed="true"
                  color="#587e27"
                  type="submit"
                  block
                  large
                  class="futuristic-btn donate-btn"
                  v-if="this.$route.name !== 'EditVisitor'"
                  :loading="this.$store.state.LoadingStore.loading"
                >
                  Register Visitor
                </v-btn>
                <v-btn
                  :depressed="true"
                  color="#f9a825"
                  type="submit"
                  block
                  large
                  class="futuristic-btn donate-btn"
                  v-if="this.$route.name === 'EditVisitor'"
                  :loading="this.$store.state.LoadingStore.loading"
                >
                  Update Visitor
                </v-btn>
              </v-container>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
    {{ updatingVisitor }}
  </v-container>
</template>

<script>
export default {
  name: 'NewVisitor',
  data() {
    return {
      start_date: this.$moment().subtract(7, 'd').format('YYYY-MM-DD'),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      responsible_staff: '',
      visitor: {
        check_in_date: '',
        check_out_date: '',
        destination: '',
        type: '',
        id_number: '',
        id_type: '',
        plate: '',
        count: 1,
        organisation: '',
        purpose: '',
        name: '',
        phone: '',
        code: '',
        staff: '',
        visitor_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      existing_visitor: false
    }
  },
  created() {
    this.$store.dispatch('get_all_countries')
    this.$store.dispatch('get_all_destinations')
    this.$store.dispatch('get_all_staffs')
    this.$store.dispatch('get_all_visitor_types')
    this.$store.dispatch('get_all_identification_types')
    if (this.$route.name === 'EditVisitor') {
      this.$store.dispatch('get_visitor', this.$route.params.visitor_id)
    }
  },
  methods: {
    findCountryCode(data) {
      var instance = this
      this.allCountries.map(function(country) {
        if (data === country.code) {
          instance.visitor.phone = '+' + country.calling_code
        }
      })
    },
    postVisitor: function() {
      this.$store.dispatch('loading_true')
      if (this.$route.name === 'EditVisitor') {
        this.$store.dispatch('update_visitor', this.visitor)
      } else {
        this.$store.dispatch('post_visitor', this.visitor)
      }
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.futuristic-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.futuristic-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.donate-btn {
  font-size: 1.1rem;
  padding: 12px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .donate-btn {
    font-size: 1rem;
    padding: 10px;
  }
}
</style>